/**
 * List Routes
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Lista from "./Lista";
import Carrinho from "./Carrinho";
import Catalogo from "./Catalogo";
import Fechamento from "./Fechamento";

const IndexPacote = ({ match, history }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route exact path={`${match.url}/carrinho/:usuarioId/:escolaId`} component={Carrinho} />
      <Route path={`${match.url}/catalogo/:escolaId?`} component={Catalogo} />
      <Route path={`${match.url}/fechamento/:usuarioId/:escolaId`} component={Fechamento} />
    </Switch>
  </div>
);

export default IndexPacote;
